import { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
// Redux
import { useDispatch, useSelector } from "react-redux";
import { validateClinician } from "../../../redux/clinicianDucks";
// Constants
import { pathHomePage, WEB_SERVICE_MIMS } from "../../../config/constants";
// Components
import {
  LoginContainer,
  LogoMimsImg,
  LogoSeparator,
  LoginForm,
  Input,
  PasswordContainer,
  RelativeContainer,
  // RelativeButton,
  ButtonSubmit,
} from "./styles";
import Axios from "../../../config/axios";
// Assets
import LogoMimsApp from "../../../assets/images/logos/logo_mims.png";
// import VisiblePassword from "../../../assets/icons/btn_visible_password.svg";
// import HidePassword from "../../../assets/icons/btn_hide_password.svg";

const Login = () => {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  // const [visiblePassword, setVisiblePassword] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [t] = useTranslation("global");

  const dispatch = useDispatch();
  const clinicianData = useSelector(({ clinician }) => clinician.data);
  const enteredAcrossLogin = useSelector(({ clinician }) => clinician.enteredAcrossLogin);

  const handleToAddClinicianActivity = () => {
    const clinicianDataToAddActivity = {
      CLINICIAN_ID: clinicianData.CLINICIAN_ID,
    };
    Axios("post", `${WEB_SERVICE_MIMS}/clinicians/login-activity`, clinicianDataToAddActivity)
      .then(({ data }) => {
        if (data.addedLoginActivity) {
          setRedirect(true);
        }
      })
      .catch((error) => {
        console.log("endpoint to add clinician activity: ", error);
      });
  };

  useEffect(() => {
    if (clinicianData.token) {
      handleToAddClinicianActivity();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clinicianData]);

  if (redirect) {
    if (enteredAcrossLogin && clinicianData.FIRST_LOGIN_TO_MIMS) {
      return <Redirect to={`${pathHomePage}/validate-password/${clinicianData.token}`} />;
    } else {
      return <Redirect to={`${pathHomePage}/home/${clinicianData.token}`} />;
    }
  }

  // const handleSetPasswordVisibility = (e) => {
  //   e.preventDefault();
  //   setVisiblePassword(!visiblePassword);
  // };

  const handleLogin = (e) => {
    e.preventDefault();
    if (!user || !password) {
      toast.error(t("emptyDataMessage"));
    } else {
      dispatch(validateClinician({ user, password, errorMessage: t("login_incorrectDataMessage"), enteredAcrossLogin: true }));
    }
  };

  const setReadOnlyAttribute = (e) => {
    e.target.setAttribute("readOnly", true);
    e.target.removeAttribute("readOnly");
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleLogin(e);
    } else {
      setReadOnlyAttribute(e);
    }
  };

  const handleNoShowCredentials = (e) => {
    setReadOnlyAttribute(e);
  };

  const removeWhitespace = (value) => value.replace(/\s/g, "");

  const handleChangeUser = (e) => {
    setUser(removeWhitespace(e.target.value));
  };

  const handleChangePassword = (e) => {
    e.preventDefault();
    setPassword(removeWhitespace(e.target.value));
  };

  return (
    <LoginContainer>
      <LogoMimsImg src={LogoMimsApp} alt="logo-mims" />
      <LogoSeparator />
      <LoginForm>
        <div>
          <label>{t("username")}</label>
          <Input
            type="text"
            placeholder={t("username")}
            value={user}
            onChange={handleChangeUser}
            readOnly
            onKeyPress={handleKeyPress}
            onKeyDown={handleKeyPress}
            onClick={handleNoShowCredentials}
            onFocus={handleNoShowCredentials}
            autoComplete={"new-password"}
            padding="0 0 0 10px"
          />
        </div>
        <PasswordContainer>
          <label>{t("password")}</label>
          <RelativeContainer>
            <Input
              // type={visiblePassword ? "text" : "password"}
              placeholder="*******"
              name="password"
              type="password"
              value={password}
              onChange={handleChangePassword}
              readOnly
              onKeyPress={handleKeyPress}
              onKeyDown={handleKeyPress}
              onClick={handleNoShowCredentials}
              onFocus={handleNoShowCredentials}
              autoComplete={"new-password"}
              padding="0 32px 0 10px"
            />
            {/* <RelativeButton onClick={handleSetPasswordVisibility}>
              <img src={visiblePassword ? HidePassword : VisiblePassword} alt="icon-password-button" />
            </RelativeButton> */}
          </RelativeContainer>
        </PasswordContainer>
        <ButtonSubmit onClick={handleLogin} disabled={clinicianData.isFetching}>
          {t("login_loginButton")}
        </ButtonSubmit>
      </LoginForm>
    </LoginContainer>
  );
};

export default Login;
